// /* eslint-disable react-hooks/exhaustive-deps */
// import {
//   Autocomplete,
//   Box,
//   CircularProgress,
//   Fab,
//   Stack,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import React, { SyntheticEvent, useEffect, useRef } from "react";
// import { CustomFormLabel, CustomTextField } from "../formsComponents";
// import { debounce } from "lodash";
// import { api } from "../../api/api";
// import AddIcon from "@mui/icons-material/Add";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import { IMasterStatusAutoSearchProps } from "./AutoCompleteSearches.types";
// import {
//   IMasterStatus,
//   initialMasterStatus,
// } from "../../redux/status/status.types";

// export const MasterStatusAutoSearch: React.FC<IMasterStatusAutoSearchProps> = (
//   props,
// ) => {
//   const {
//     label,
//     value,
//     onSelect,
//     disabled,
//     hideAddButton,
//     company_outlet_uuid,
//     error,
//     helperText,
//     isHighlighted = false,
//     showAllOption = false,
//   } = props;
//   const [options, setOptions] = React.useState<readonly IMasterStatus[]>([]);
//   const [loading, setLoading] = React.useState(false);
//   const [search, setSearchText] = React.useState<any>("");
//   const [openProduct, setOpenProduct] = React.useState(false);
//   const initialLoad = useRef(false);

//   const displayOptions = React.useMemo(() => {
//     if (showAllOption) {
//       const allOption: IMasterStatus = {
//         master_status_uuid: null,
//         status_uuid: "-1",
//         drive_status_uuid: "-1",
//         name: "All",
//         actual_status: "-1",
//         description: "",
//         status: "ACTIVE",
//         created_by_uuid: "",
//         created_by_name: "",
//         modified_by_uuid: "",
//         modified_by_name: "",
//       };
//       return [allOption, ...options];
//     }
//     return options;
//   }, [options, showAllOption]);
//   const fetchSuggestion = async (enteredValue: string) => {
//     setLoading(true);
//     try {
//       let searchQuery = "";
//       if (enteredValue.length > 0) {
//         searchQuery = `columns=name&value=${enteredValue}&`;
//       }

//       const res = await api.get(
//         `/dataManagement/get-drive-status?company_outlet_uuid=${company_outlet_uuid}`,
//       );

//       const data: IMasterStatus[] = res.data.data;
//       // Map status_uuid to drive_status_uuid since API returns status_uuid
//       const mappedData = data.map((status) => ({
//         ...status,
//         drive_status_uuid: status.drive_status_uuid || status.status_uuid,
//       }));
//       setOptions(mappedData);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const debounceFn = React.useCallback(debounce(fetchSuggestion, 800), []);

//   const getOptionLabel = (option: string | IMasterStatus) => {
//     if (typeof option === "string") {
//       return option;
//     }
//     if (option.name) {
//       return `${option.name}`;
//     }
//     return `${option.status_uuid || ""}`;
//   };

//   const handleToggle = () => {
//     setOpenProduct(!openProduct);
//   };

//   const handleFocus = () => {
//     if (!initialLoad.current) {
//       fetchSuggestion("");
//       initialLoad.current = true;
//     }
//   };

//   useEffect(() => {
//     if (search && search !== value) {
//       debounceFn(search);
//     }
//   }, [search, value, debounceFn]);

//   const handleChange = (
//     event: SyntheticEvent<Element, Event>,
//     value: string | IMasterStatus | null,
//   ) => {
//     if (typeof value === "object" && value !== null) {
//       // Ensure drive_status_uuid is set (use status_uuid as fallback)
//       const valueWithDriveStatusUuid = {
//         ...value,
//         drive_status_uuid: value.drive_status_uuid || value.status_uuid,
//       };
//       onSelect?.(valueWithDriveStatusUuid);
//     } else if (value === null) {
//       // When cleared, if showAllOption is true, select "All", otherwise pass null
//       if (showAllOption) {
//         const allOption: IMasterStatus = {
//           master_status_uuid: null,
//           status_uuid: "-1",
//           drive_status_uuid: "-1",
//           name: "All",
//           actual_status: "-1",
//           description: "",
//           status: "ACTIVE",
//           created_by_uuid: "",
//           created_by_name: "",
//           modified_by_uuid: "",
//           modified_by_name: "",
//         };
//         onSelect?.(allOption);
//       } else {
//         onSelect?.(initialMasterStatus);
//       }
//     } else {
//       onSelect?.(initialMasterStatus);
//     }
//   };
//   return (
//     <>
//       <Box display="flex" justifyContent={"flex-start"} alignItems="center">
//         {/* {label && (
//           <CustomFormLabel display={"block"}>{` ${label}  `}</CustomFormLabel>
//         )} */}

//         {!hideAddButton &&
//           search.length > 0 &&
//           options.length === 0 &&
//           !loading && (
//             <Box
//               sx={{
//                 paddingLeft: 1,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "flex-start",
//                 marginTop: 1,
//               }}
//               onClick={handleToggle}
//             >
//               <AddCircleIcon fontSize="small" color="primary" />
//               <Typography
//                 variant="h6"
//                 color="primary"
//                 marginLeft={0.5}
//                 marginTop={0.3}
//                 fontWeight={500}
//               >
//                 Add Item
//               </Typography>
//             </Box>
//           )}
//       </Box>

//       <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
//         <Autocomplete
//           id="org-status-auto-search"
//           fullWidth
//           freeSolo
//           sx={{
//             ".MuiOutlinedInput-root": {
//               paddingTop: "2px",
//               paddingBottom: "2px",
//               fontSize: "0.8rem",
//               color: "rgb(38, 38, 38)",
//               width: "100%",
//             },
//             ...(value &&
//               value !== "" &&
//               typeof value === "object" &&
//               value.name &&
//               value.name !== "-1" &&
//               value.name !== "All" && {
//                 backgroundColor: "#fff2c7",
//                 borderRadius: 1,
//               }),
//             // Active filter highlight styles
//             ...(isHighlighted && {
//               "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
//                 borderColor: "warning.main",
//                 borderWidth: "2px !important",
//               },
//               "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                 {
//                   borderColor: "warning.main",
//                 },
//               "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                 {
//                   borderColor: "warning.main",
//                 },
//             }),
//             ...(value &&
//               value !== "" &&
//               typeof value === "object" &&
//               value.name &&
//               value.name !== "-1" &&
//               value.name !== "All" && {
//                 "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
//                   borderColor: "warning.main",
//                   borderWidth: "2px",
//                 },
//                 "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "warning.main",
//                   },
//                 "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                   {
//                     borderColor: "warning.main",
//                     borderWidth: "2px",
//                   },
//               }),
//           }}
//           getOptionLabel={getOptionLabel}
//           isOptionEqualToValue={(option, value) =>
//             typeof option !== "string" && typeof value !== "string"
//               ? option.name === value.name
//               : option === value
//           }
//           filterOptions={(x) => x}
//           disabled={disabled}
//           options={displayOptions}
//           onFocus={handleFocus} // Only fetch data on first focus
//           includeInputInList
//           value={value}
//           clearOnBlur={false}
//           loading={loading}
//           noOptionsText="No Items"
//           onChange={handleChange}
//           onInputChange={(event, newInputValue) => {
//             if ((event && event.type === "change") || !newInputValue) {
//               setSearchText(newInputValue);
//             }
//           }}
//           renderInput={(params) => (
//             <CustomTextField
//               label={label}
//               {...params}
//               fullWidth
//               error={!!error}
//               helperText={helperText}
//               value={params.inputProps.value}
//               InputProps={{
//                 ...params.InputProps,
//                 endAdornment: (
//                   <React.Fragment>
//                     {loading && <CircularProgress color="inherit" size={20} />}
//                     {params.InputProps.endAdornment}
//                   </React.Fragment>
//                 ),
//               }}
//             />
//           )}
//         />
//         {!label &&
//           !hideAddButton &&
//           search.length > 0 &&
//           options.length === 0 &&
//           !loading && (
//             <Box>
//               <Tooltip title="Create Product">
//                 <Fab
//                   size="small"
//                   color="primary"
//                   aria-label="add"
//                   onClick={handleToggle}
//                 >
//                   <AddIcon />
//                 </Fab>
//               </Tooltip>
//             </Box>
//           )}
//       </Stack>
//     </>
//   );
// };

/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Fab,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { SyntheticEvent, useEffect, useRef } from "react";
import { debounce } from "lodash";
import { api } from "../../api/api";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { IMasterStatusAutoSearchProps } from "./AutoCompleteSearches.types";
import { EnrAutoComplete } from "../basic/EnrAutoComplete";
import {
  IMasterStatus,
  initialMasterStatus,
} from "../../redux/status/status.types";

/* ---------------- ALL OPTION CONSTANT ---------------- */
const ALL_OPTION: IMasterStatus = {
  master_status_uuid: null,
  status_uuid: "-1",
  drive_status_uuid: "-1",
  name: "All",
  actual_status: "-1",
  description: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
};

export const MasterStatusAutoSearch: React.FC<IMasterStatusAutoSearchProps> = (
  props,
) => {
  const {
    label,
    value,
    onSelect,
    disabled,
    hideAddButton,
    company_outlet_uuid,
    error,
    helperText,
    isHighlighted = false,
    showAllOption = false,
    advancedFilters,
  } = props;

  const [options, setOptions] = React.useState<readonly IMasterStatus[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearchText] = React.useState("");
  const initialLoad = useRef(false);

  /* ---------------- FETCH OPTIONS ---------------- */
  const fetchSuggestion = async (enteredValue: string) => {
    setLoading(true);
    try {
      let searchQuery = "";
      if (enteredValue?.length > 0) {
        searchQuery = `columns=name&value=${enteredValue}&`;
      }

      const advanceFilterParam =
        advancedFilters && advancedFilters.length > 0
          ? `&advanceFilter=${encodeURIComponent(
              JSON.stringify(advancedFilters),
            )}`
          : "";

      const res = await api.get(
        `/dataManagement/get-drive-status?company_outlet_uuid=${company_outlet_uuid}&status=ACTIVE${advanceFilterParam}`,
      );

      const data: IMasterStatus[] = res.data.data || [];

      const mappedData = data.map((status) => ({
        ...status,
        drive_status_uuid: status.drive_status_uuid || status.status_uuid,
      }));

      setOptions(mappedData);
    } catch (error) {
      console.error("Error fetching status list:", error);
    } finally {
      setLoading(false);
    }
  };

  // Stable debounced fetcher tied to the current outlet. Avoids the
  // useCallback(debounce(...), []) anti-pattern (per-render allocation + stale
  // closure).
  const debounceFn = React.useMemo(
    () => debounce(fetchSuggestion, 800),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [company_outlet_uuid],
  );

  // Cancel any pending debounced call on unmount / when replaced.
  useEffect(() => () => debounceFn.cancel(), [debounceFn]);

  /* ---------------- OPTIONS WITH ALL ---------------- */
  const displayOptions = React.useMemo(() => {
    if (showAllOption) {
      return [ALL_OPTION, ...options];
    }
    return options;
  }, [options, showAllOption]);

  /* ---------------- RESOLVE VALUE (🔥 FIX) ---------------- */
  const resolvedValue = React.useMemo(() => {
    // When value is "-1" or empty → force-select All option
    if (
      showAllOption &&
      (value === "-1" ||
        value === "" ||
        value === null ||
        (typeof value === "object" && value.actual_status === "-1"))
    ) {
      return ALL_OPTION;
    }

    return value;
  }, [value, showAllOption]);

  /* ---------------- INPUT LABEL ---------------- */
  const getOptionLabel = (option: string | IMasterStatus) => {
    if (typeof option === "string") return option;
    return option?.name || "";
  };

  /* ---------------- FIRST FOCUS LOAD ---------------- */
  const handleFocus = () => {
    if (!initialLoad.current) {
      fetchSuggestion("");
      initialLoad.current = true;
    }
  };

  useEffect(() => {
    if (search && search !== value) {
      debounceFn(search);
    }
  }, [search, value, debounceFn]);

  /* ---------------- CHANGE HANDLER ---------------- */
  const handleChange = (
    event: SyntheticEvent,
    newValue: string | IMasterStatus | null,
  ) => {
    if (newValue === null) {
      onSelect?.(showAllOption ? ALL_OPTION : initialMasterStatus);
      return;
    }

    if (typeof newValue === "object") {
      onSelect?.({
        ...newValue,
        drive_status_uuid: newValue.drive_status_uuid || newValue.status_uuid,
      });
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center">
        {!hideAddButton &&
          search.length > 0 &&
          options.length === 0 &&
          !loading && (
            <Box
              sx={{
                paddingLeft: 1,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: 1,
              }}
            >
              <AddCircleIcon fontSize="small" color="primary" />
              <Typography
                variant="h6"
                color="primary"
                ml={0.5}
                fontWeight={500}
              >
                Add Item
              </Typography>
            </Box>
          )}
      </Box>

      <Stack direction="row" spacing={1}>
        <EnrAutoComplete
          fullWidth
          freeSolo
          options={displayOptions as IMasterStatus[]}
          value={resolvedValue as any}
          // Highlight when explicitly flagged OR when a real status is selected
          // (value is an object that isn't the "All"/"-1" sentinel).
          isHighlighted={
            isHighlighted ||
            !!(
              value &&
              value !== "" &&
              typeof value === "object" &&
              value.name &&
              value.name !== "-1" &&
              value.name !== "All"
            )
          }
          // Input (default renderInput handles label/error/loading)
          label={label}
          error={typeof error === "string" ? error : undefined}
          helperText={helperText}
          loading={loading}
          // "All" sentinel row → italic/muted + divider (shared static styling)
          isStaticOption={(option: any) =>
            !!showAllOption &&
            (option?.actual_status === "-1" || option?.name === "All")
          }
          getOptionLabel={getOptionLabel}
          getOptionRowLabel={(option: any) =>
            typeof option === "string" ? option : option?.name || ""
          }
          isOptionEqualToValue={(option: any, val: any) =>
            typeof option !== "string" &&
            typeof val !== "string" &&
            option.actual_status === val.actual_status
          }
          filterOptions={(x) => x}
          disabled={disabled}
          onFocus={handleFocus}
          clearOnBlur={false}
          onChange={handleChange as any}
          onInputChange={(event, newInputValue) => {
            if (event?.type === "change" || !newInputValue) {
              setSearchText(newInputValue);
            }
          }}
        />

        {!label &&
          !hideAddButton &&
          search.length > 0 &&
          options.length === 0 &&
          !loading && (
            <Tooltip title="Create Status">
              <Fab size="small" color="primary">
                <AddIcon />
              </Fab>
            </Tooltip>
          )}
      </Stack>
    </>
  );
};
